var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.value === 'number')?_c('span',{staticClass:"rating"},[_c('div',{staticClass:"rating__wrap"},[_c('div',{staticClass:"rating__stars",style:(`width: ${_vm.value}%`)})]),(_vm.linkUrl && _vm.linkText)?_c('a',{staticClass:"rating__link",attrs:{"href":_vm.linkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkText))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }